<app-cancel-open-banking-popin (continue)="closePopin()" [show]="isPopinOpen"></app-cancel-open-banking-popin>

<div class="flex flex-col flex-1 justify-between h-full">
  <div class="text-center flex-1 content-center">
    <img src="../../../../../assets/images/svg/cross-error.svg" class="h-8 w-8 m-auto" />
    <p class="text-secondary font-bold mt-7 text-xl">{{ 'none_account_has_been_detected' | translate }}</p>
    <p class="mt-3">{{ 'you_can_still_connect_to_another_bank' | translate }}</p>
  </div>
  <div class="flex flex-col">
    <button
      class="bg-primary font-bold text-secondary m-auto flex-1 pt-3 pb-3 rounded-full mb-6 w-full text-xl"
      (click)="connectToOtherBank()"
    >
      {{ 'connect_to_another_bank' | translate }}
    </button>
    <button
      class="bg-gray-100 font-bold text-secondary m-auto flex-1 pt-3 pb-3 rounded-full mb-6 w-full text-sm"
      (click)="openPopin()"
    >
      {{ 'come_back_to_classic_form' | translate }}
    </button>
  </div>
</div>
